// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.QuestionsHeader {
  width: 100%;
  padding: 0;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
}
.QuestionsHeader .QuestionsHeader-TitleGroup .QuestionsHeader-Title {
  text-transform: uppercase;
  margin-bottom: 0.25rem;
}
.QuestionsHeader .QuestionsHeader-TitleGroup .QuestionsHeader-Subtitle {
  font-size: 1.2rem;
  margin-bottom: 0;
}
.QuestionsHeader .QuestionsHeader-AddButton {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-shrink: 0;
  background-color: var(--bs-primary);
  color: #fff;
  border: none;
  border-radius: 0.4rem;
  padding: 0.6rem 1rem;
  font-weight: 600;
}
.QuestionsHeader .QuestionsHeader-AddButton i {
  font-size: 0.9rem;
}
.QuestionsHeader .QuestionsHeader-AddButton:hover, .QuestionsHeader .QuestionsHeader-AddButton:focus-visible {
  background-color: var(--bs-primary-dark, #1a2f5c);
}
.QuestionsHeader .QuestionsHeader-AddButton:focus-visible {
  outline: 2px solid var(--bs-primary);
  outline-offset: 2px;
}`, "",{"version":3,"sources":["webpack://./src/features/Settings/pages/Questions/components/QuestionsHeader/styles.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;AACF;AAEI;EACE,yBAAA;EACA,sBAAA;AAAN;AAEI;EACE,iBAAA;EACA,gBAAA;AAAN;AAIE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,cAAA;EACA,mCAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,oBAAA;EACA,gBAAA;AAFJ;AAII;EACE,iBAAA;AAFN;AAKI;EAEE,iDAAA;AAJN;AAOI;EACE,oCAAA;EACA,mBAAA;AALN","sourcesContent":[".QuestionsHeader {\n  width: 100%;\n  padding: 0;\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 1rem;\n\n  .QuestionsHeader-TitleGroup {\n    .QuestionsHeader-Title {\n      text-transform: uppercase;\n      margin-bottom: 0.25rem;\n    }\n    .QuestionsHeader-Subtitle {\n      font-size: 1.2rem;\n      margin-bottom: 0;\n    }\n  }\n\n  .QuestionsHeader-AddButton {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    flex-shrink: 0;\n    background-color: var(--bs-primary);\n    color: #fff;\n    border: none;\n    border-radius: 0.4rem;\n    padding: 0.6rem 1rem;\n    font-weight: 600;\n\n    i {\n      font-size: 0.9rem;\n    }\n\n    &:hover,\n    &:focus-visible {\n      background-color: var(--bs-primary-dark, #1a2f5c); // fallback if no darker shade var exists\n    }\n\n    &:focus-visible {\n      outline: 2px solid var(--bs-primary);\n      outline-offset: 2px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
